module.exports = __webpack_public_path__ + "static/img/6.2ff52ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/6.png
// module id = EWpu
// module chunks = 1